<template>
  <!-- Horná lišta len na mobile (na desktope je logo aj používateľ v ľavom paneli). -->
  <header class="mobile-topbar" data-shell="topbar">
    <button type="button" class="mobile-topbar__btn" aria-label="Otvoriť menu" @click="$emit('toggle-drawer')">
      <v-icon icon="mdi-menu" size="22" />
    </button>

    <router-link to="/" class="mobile-topbar__brand" aria-label="Optika MANIA — prehľad">
      <BrandLogo :width="78" alt="Optika MANIA" />
    </router-link>

    <NotifikacieZvoncek variant="topbar" />

    <router-link to="/profile" class="mobile-topbar__avatar" :aria-label="`Profil: ${userName}`">
      {{ userInitials }}
    </router-link>
  </header>
</template>

<script>
import { defineComponent } from 'vue'
import BrandLogo from '@/components/brand/BrandLogo.vue'
import NotifikacieZvoncek from '@/components/common/NotifikacieZvoncek.vue'
import { useAppNavigation } from '@/composables/useAppNavigation'

export default defineComponent({
  name: 'AppHeader',
  components: { BrandLogo, NotifikacieZvoncek },
  emits: ['toggle-drawer'],

  setup() {
    const { userName, userInitials } = useAppNavigation({ poll: false })
    return { userName, userInitials }
  },
})
</script>

<style lang="scss" scoped>
.mobile-topbar {
  position: sticky;
  top: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  gap: 8px;
  height: calc(var(--mobile-topbar-height) + env(safe-area-inset-top, 0px));
  padding: env(safe-area-inset-top, 0px) 12px 0 6px;
  background: rgba(255, 255, 255, 0.82);
  border-bottom: 0.5px solid rgba(16, 16, 16, 0.1);
  -webkit-backdrop-filter: saturate(180%) blur(20px);
  backdrop-filter: saturate(180%) blur(20px);
}

@supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
  .mobile-topbar {
    background: #ffffff;
  }
}

.mobile-topbar__btn {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  color: var(--text-primary);

  &:active {
    background: var(--surface-pearl);
  }
}

.mobile-topbar__brand {
  display: flex;
  align-items: center;
  margin-right: auto;
}

.mobile-topbar__avatar {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 11px;
  background: linear-gradient(140deg, var(--brand-ruby) 0%, var(--ruby-600) 100%);
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
}
</style>
